import { TopList } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import ChartTooltip from 'modules/insights/components/ChartTooltip'
import TooltipLegend from 'modules/insights/components/TooltipLegend'
import type HeadcountByTeam from 'modules/insights/lib/metrics/headcountByTeam'

type Props = {
  headcountByTeam: HeadcountByTeam
}

const HeadcountByTeamChart = ({ headcountByTeam }: Props) => {
  const data = headcountByTeam.generate()

  return (
    <TopList
      leftColumnHeader={i18n.t('insights.widgets.headcount_by_team.team_header')}
      rightColumnHeader={i18n.t('insights.widgets.shared.headcount')}
      data={data}
      tooltip={({ label, value }) => (
        <ChartTooltip title={label}>
          <TooltipLegend
            color="viridian1000"
            name={i18n.t('insights.widgets.shared.headcount')}
            value={value}
          />
        </ChartTooltip>
      )}
    />
  )
}

export default HeadcountByTeamChart
